<template>
  <l-map
    v-if="show"
    id="map"
    ref="map"
    :center="center"
    :zoom="zoom"
    :options="mapOptions"
    style="width:100%; height:100%"
    @ready="onReady"
  >
    <l-tile-layer
      :url="url"
    />
    <l-control
      v-if="response.groups.length > 1 || response.filters.length > 0"
      position="topleft"
    >
      <button
        type="button"
        class="menubutton"
        aria-label="Menu"
        @click="toggleMenu"
      >
        <div class="menubutton__icon">
          <svg
            viewBox="0 0 100 80"
            width="14"
            height="14"
            fill="currentColor"
          >
            <rect
              width="100"
              height="20"
            />
            <rect
              y="30"
              width="100"
              height="20"
            />
            <rect
              y="60"
              width="100"
              height="20"
            />
          </svg>
        </div>
        <div class="menubutton__label">
          Filter
        </div>
      </button>
    </l-control>
    <l-control
      v-if="response.groups.length > 0"
      v-show="menuVisible"
      ref="menuctrl"
      position="topleft"
      class="controlContainer"
      :disable-scroll-propagation="true"
    >
      <div class="controlContainerSlider">
        <div
          v-for="group in response.groups"
          :key="group.identifier"
          class="controlGroup"
        >
          <button
            :style="{background: group.color}"
            :class="{'active': isGroupActive(group)}"
            @click="toggleGroup(group)"
          >
            <svg
              v-if="isGroupActive(group)"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              width="14"
              height="14"
              viewBox="0 0 24 24"
            ><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" /></svg>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              width="14"
              height="14"
              viewBox="0 0 24 24"
            ><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z" /></svg><span>{{ group.label }}</span>
          </button>
        </div>

        <div
          v-if="response.filters.length > 0"
        >
          <p class="controlContainerTitle">
            Filter
          </p>
          <div
            v-for="filter in response.filters"
            :key="filter.id"
            class="controlGroup"
          >
            <button
              :class="{'active': isFilterActive(filter)}"
              @click="toggleFilter(filter)"
            >
              <svg
                v-if="isFilterActive(filter)"
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              ><path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.25 17.292l-4.5-4.364 1.857-1.858 2.643 2.506 5.643-5.784 1.857 1.857-7.5 7.643z" /></svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              ><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z" /></svg><span>{{ filter.label }}</span>
            </button>
          </div>
        </div>
      </div>
    </l-control>
    <l-control
      v-if="activeMarker"
      position="bottomright"
      class="markerDetailWindow"
      :disable-scroll-propagation="true"
    >
      <div class="markerDetail">
        <div class="markerLead">
          <a
            v-if="activeMarker.content.link"
            :target="response.config.link_target"
            :href="activeMarker.content.link"
          >
            <svg
              aria-hidden="true"
              data-prefix="fas"
              data-icon="link"
              class="svg-inline--fa fa-link fa-w-16"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            ><path
              fill="currentColor"
              d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
            /></svg>
            <span>{{ activeMarker.content.title.trim() }}</span>
          </a>
          <span v-else>{{ activeMarker.content.title.trim() }}</span>
          <div
            class="markerClose"
            @click="closeMarker"
          >
            <svg
              aria-hidden="true"
              data-prefix="far"
              data-icon="times-circle"
              class="svg-inline--fa fa-times-circle fa-w-16"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            ><path
              fill="currentColor"
              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
            /></svg>
          </div>
        </div>
        <p
          class="markerText"
          v-html="activeMarker.content.teaser"
        />
        <div 
          v-if="activeMarker.content.image"
          style="max-height:350px;" 
        >
          <img
            :src="activeMarker.content.image"
            class="img-fluid"
          >
        </div>
      </div>
    </l-control>
    <l-control-zoom position="topright" />
    <v-marker-cluster ref="cluster">
      <l-marker 
        v-for="(mark,index) in markers"
        :key="index"
        :lat-lng="marker(mark.content)"
        :icon="icon(mark)"
        @click="activateMarker(mark)"
      >
        <l-tooltip
          :options="{'offset': [20,-15]}"
        >
          {{ mark.content.title }}
        </l-tooltip>
      </l-marker>
    </v-marker-cluster>
  </l-map>
</template>

<script>
import L from 'leaflet';
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LControl, LControlZoom, LTooltip } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LControlZoom,
    LTooltip,
    'v-marker-cluster': Vue2LeafletMarkerCluster
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    token: {
      type: [String],
      required: true
    },
    api: {
      type: [String],
      default: 'https://api.flyo.cloud/integration/map'
    },
    cache: {
      type: [String],
      default: ''
    },
    lat: {
      type: String,
      default: ''
    },
    lng: {
      type: String,
      default: ''
    },
    filters: {
      type: String,
      default: "[]"
    }
  },

  data:() => ({
    show: false,
    center: [0,0],
    zoom: 15, // this only is used when using lat,lng props, otherwise fitbound works
    //url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png?api_key=352732c0-fc2c-401a-830e-f53caa5d6741',
    mapOptions: {
      zoomControl: false
    },
    response: {
      markers: [],
      groups: [],
      filters: [],
      config: {
        link_target: "_blank"
      }
    },
    menuVisible: false,
    activeMarker: false,
    activeGroups: [],
    activatedFilters: [],
  }),
  computed: {
    fetchUrl : function() {
      let url = `${this.api}/${this.id}/${this.token}`
      if (this.cache.length > 0) {
        url = url + '?' + this.cache + '=' + Date.now()
      }
      return url
    },
    markers: function() {
      var markers = this.response.markers;

      markers = markers.filter(marker => {
        const filteredArray = marker.groups.filter(value => this.activeGroups.includes(value));
        
        return filteredArray.length > 0
      })

      if (this.activatedFilters.length == 0) {
        return markers
      }

      return markers.filter(marker => {
        return marker.filters.some(v => this.activatedFilters.includes(parseInt(v)))
      })
    }
  },
  destroyed() {
    this.marks = []
  },
  mounted() {
    this.fetchData()

    // parse input string filter property to active filters
    const filters = JSON.parse(this.filters)
    this.activatedFilters = filters.map(value => { return parseInt(value) })
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
    },
    closeMarker() {
      this.activeMarker = false
    },
    activateMarker(mark) {
      if (this.activeMarker && mark.identifier == this.activeMarker.identifier) {
        this.activeMarker = false;
      } else {
        this.activeMarker = mark
        fetch(mark.content.metric)
      }
    },
    toggleGroup(group) {
      const index = this.activeGroups.indexOf(group.identifier)
      if (index == -1) {
        this.activeGroups.push(group.identifier)
      } else {
        this.activeGroups.splice(index, 1)
      }

      this.fitBounds()
    },
    toggleFilter(filter) {
      const index = this.activatedFilters.indexOf(filter.id)
      if (index == -1) {
        this.activatedFilters.push(filter.id)
      } else {
        this.activatedFilters.splice(index, 1)
      }

      this.fitBounds()
    },
    isGroupActive(group) {
      return this.activeGroups.includes(group.identifier)
    },
    isFilterActive(filter) {
      return this.activatedFilters.includes(filter.id)
    },
    marker(item) {
      return latLng(item.lat, item.lng)
    },
    icon(item){
      return L.divIcon({
        className: "my-custom-pin",
        iconAnchor: [25,35],
        html: `<svg version="1.1" height="40" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 492.452 492.452" style="enable-background:new 0 0 492.452 492.452;" xml:space="preserve">
<path id="XMLID_152_" d="M246.181,0C127.095,0,59.533,102.676,84.72,211.82c17.938,77.722,126.259,280.631,161.462,280.631
	c32.892,0,143.243-202.975,161.463-280.631C432.996,103.74,365.965,0,246.181,0z M246.232,224.97
	c-34.38,0-62.244-27.863-62.244-62.244c0-34.381,27.864-62.244,62.244-62.244c34.38,0,62.244,27.863,62.244,62.244
	C308.476,197.107,280.612,224.97,246.232,224.97z" style="fill:${item.color};"/>
</svg>
`
      });
    },
    fetchData() {
      fetch(this.fetchUrl)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json()
      })
      .then(data => {
        data.markers = Object.values(data.markers).map(item => {
          item.visible = false;
          return item
        })
        this.response = data

        this.activeGroups = data.groups.map(item => item.identifier)
        this.show = true
      })
      .catch((error) => {
        console.error('Flyo Map Server Error:', error);
      });
    },
    fitBounds() {
      this.$nextTick(() => {
        this.$refs.cluster.mapObject.refreshClusters()
        const bounds = this.$refs.cluster.mapObject.getBounds()
        if (bounds.isValid()) {
          this.$refs.map.mapObject.fitBounds(bounds);
          this.$refs.map.mapObject.invalidateSize(true)
        }
      })
    },
    onReady() {
      if (this.lat && this.lat.length > 0 && this.lng && this.lng.length > 0) {
        this.center = latLng(this.lat, this.lng)
      } else {
        this.fitBounds()
      } 
    },
  },
}
</script>

<style>
html,body {
  height: 100%;
  width: 100%;
  margin:0px;
  padding:0px;
}

.controlContainer {
  font-size:0.8rem;
  overflow-y: auto;
  max-height: calc(100vh - 40px);
  background: rgba(255, 255, 255, .5);
  padding: 10px;
  border-radius: 5px;
}

.controlContainerTitle {
  font-weight: 500;
  font-size: 1.2em;
  margin-top: 20px;
  margin-bottom: 5px;
}

.controlGroup {
  margin:4px 0px;
}

.controlGroup button {
  position: relative;
  padding: 8px 10px 8px 30px;
  text-transform: uppercase;
  color: #fff;
  background-color:#000;
  opacity: 0.6;
  border: 0px;
  border-radius: 30px;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  font-size: 0.7rem;
}

.controlGroup svg {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.controlGroup button:hover {
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.4);
  transform: translateY(-1px);
  opacity: 1;
}

.controlGroup .active {
  opacity: 1;
}

.markerDetail {
  position: relative;
  width: 425px;
  max-height: 650px;
  background-color:rgba(255, 255, 255, 0.8);
  color:#000;
  min-height: 200px;
  border-radius: 5px;
  padding: 20px;
  overflow: auto;
}

.markerClose {
  display: inline-block;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  margin-left: auto;
  cursor: pointer;
}

.markerLead {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-weight: bold;
  font-size: 1.0rem;
  margin: 0px;
  padding: 0;
}

.markerLead > a,
.markerLead > span {
  margin-right: 20px;
}

.markerLead a {
  color: #000;
  text-decoration: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.markerLead a svg {
  text-decoration: none;
  margin-right: 15px;
  width: 18px;
  height: 18px;
}

.markerLead a span {
  display: inline-block;
  text-decoration: none;
  white-space: break-spaces;
}

.markerText {
  font-size:1rem;
}

.img-fluid {
  width: 100%;
  height:100%;
  display: block;
  margin: auto;
}

.menubutton {
  position: relative;
  text-transform: uppercase;
  color: #000;
  border: 0px;
  cursor: pointer;
  outline: none;
  font-size: 1rem;
  background: none;
}

.menubutton__icon {
  display: inline-block;
  position: relative;
  vertical-align: middle;
  background-color:#fff;
  border-radius: 50%;
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  font-size: 1rem;
  width: 40px;
  height: 40px;
}

.menubutton__icon svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
}

.menubutton__label {
  display: inline-block;
  vertical-align: middle;
  padding: 0 0 0 10px;
}

@media screen and (max-width:720px) {
  /* Zusätzliche Regeln für kleinere Monitore  */
  .markerDetail {
    width:100%;
    max-height:300px;
  }

  .markerDetailWindow {
    padding:10px;
    padding-right:40px;
  }

  .controlContainer {
    max-height: calc(100vh - 100px);
  }
}

@import "./../../node_modules/leaflet.markercluster/dist/MarkerCluster.css";
@import "./../../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css";
@import "./../../node_modules/leaflet/dist/leaflet.css";
</style>
